{
  "version": 4,
  "flows": {
    "default": {
      "destinations": {
        "demo": {
          "package": "@walkeros/destination-demo",
          "config": {
            "settings": {
              "name": "Simple Demo",
              "values": ["name", "data", "user", "consent"]
            }
          }
        }
      },
      "config": {
        "platform": "web",
        "bundle": {
          "packages": {
            "@walkeros/collector": {
              "version": "latest",
              "imports": ["startFlow"]
            },
            "@walkeros/destination-demo": {
              "version": "latest"
            }
          }
        }
      }
    }
  }
}
